import { z } from "zod/v4";

export const memberSummarySchema = z.object({
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
	user_id: z.string().uuid(),
});

export const groupMemberStatusSchema = z.enum(["registered", "waitlisted", "cancelled"]);

export const trainingGroupMemberSchema = z.object({
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
	group_id: z.string().uuid(),
	id: z.string().uuid(),
	member_type: z.string().nullable().optional(),
	registered_at: z.coerce.date(),
	role: z.string().nullable().optional(),
	skill_level_name: z.string().nullable().optional(),
	status: groupMemberStatusSchema,
	user_id: z.string().uuid(),
});

export const memberSuggestionSchema = z.object({
	availability_match: z.boolean(),
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
	matching_slots: z.number(),
	member_type: z.string().nullable().optional(),
	role: z.string().nullable().optional(),
	skill_level_name: z.string().nullable().optional(),
	skill_match: z.boolean(),
	user_id: z.string(),
});

export const bulkAddMembersSchema = z.object({
	user_ids: z.array(z.string().uuid()),
});

export const bulkAddMembersResponseSchema = z.object({
	registered: z.number().int(),
	waitlisted: z.number().int(),
});

export const removeGroupMemberResponseSchema = z.object({
	promoted_user_id: z.string().uuid().nullable().optional(),
	promoted_user_name: z.string().nullable().optional(),
});
